module.exports = "<svg id=\"2035e716-e2f6-4389-8640-19b0330e1eb9\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>nav-contact</title><path d=\"M4,11.8a3.41,3.41,0,0,0-1.38.28l21.2,18.07a2,2,0,0,0,2.19,0l21.2-18.07a3.41,3.41,0,0,0-1.38-.28ZM1,13.66a3.4,3.4,0,0,0-.37,1.54V37.81A3.38,3.38,0,0,0,4,41.2H45.86a3.38,3.38,0,0,0,3.39-3.39V15.19a3.4,3.4,0,0,0-.37-1.54L27.5,31.87a4,4,0,0,1-5.12,0Z\" style=\"fill:#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/nav-contact.svg
// module id = 548
// module chunks = 1